function Button(props) {
  return (
    <button className={props.isPrimary ? 'primary' : 'secondary'}>
      {props.isPrimary ? 'My List' : 'Explore'}
    </button>
  );
}

export default Button;